App.SandboxController = Em.Controller.extend
  buttonIsLoading: false

  slideName: 'superman'

  begbederQuestion: 'nope'

  chosenFood: Em.A([
    { name: 'помидоры' }
    { name: 'лук' }
    { name: 'зелень' }
  ])

  foodCollection: Em.A([
    { name: 'охери' },
    { name: 'шоколад' }
  ])

  initBitches: (->
    bitchesArray = Em.A()
    bitchesArray.pushObject(Em.Object.create( name: 'Лешка', isTwerking: false))
    bitchesArray.pushObject(Em.Object.create( name: 'Борька', isTwerking: false))
    bitchesArray.pushObject(Em.Object.create( name: 'Тишечка', isTwerking: true))
    @set('bitches', bitchesArray)
  ).on('init')

  doesLikeCats: true
  doesLikeDogs: false
  testDate: ( ->
    new Date
  ).property()

  initiallyNullDate: null

  numeralValue: 100

  popoverPlacement: 'bottom'
  showPopover: true

  loveConfession: (->
    animals = []
    animals.push('кошечек') if @get('doesLikeCats')
    animals.push('собачек') if @get('doesLikeDogs')

    if Em.isEmpty(animals)
      'Я никого не люблю'
    else
      "Я люблю #{animals.join(' и ')}"
  ).property(
    'doesLikeDogs',
    'doesLikeCats')

  segmentState: 'batman'

  couriers: [
    Em.Object.create({id:1, name:"Ерлан Маширов"})
    Em.Object.create({id:2, name:"Нурбек Авито"})
    Em.Object.create({id:3, name:"Джонибек Тагоев"})
    Em.Object.create({id:4, name:"Дмитрий Проскуровский"})
    Em.Object.create({id:5, name:"Таир Джанибековский"})
    Em.Object.create({id:6, name:"Кирилл Цай"})
    Em.Object.create({id:7, name:"Айхал Рязанский"})
    Em.Object.create({id:8, name:"Равиль Бердымухамедов"})
    Em.Object.create({id:9, name:"Андрей Мотовилов"})
    Em.Object.create({id:10, name:"Суперман"})
    Em.Object.create({id:11, name:"Ватман"})
    Em.Object.create({id:12, name:"Спайдерман"})
    Em.Object.create({id:13, name:"Лоцман"})
    Em.Object.create({id:14, name:"Айсберг"})
    Em.Object.create({id:15, name:"Кенигсберг"})
  ]

  selectedCouriers: [
    Em.Object.create({id:3, name:"Джонибек Тагоев"})
  ]

  notifier: Em.inject.service()

  cities: ["Москва", "Санкт-Петербург", "Новосибирск", "Екатеринбург", "Нижний Новгород", "Казань", "Самара", "Омск", "Челябинск", "Ростов-на-Дону", "Уфа", "Волгоград", "Красноярск", "Пермь", "Воронеж", "Саратов", "Краснодар", "Тольятти", "Барнаул", "Тюмень", "Ижевск", "Ульяновск", "Иркутск", "Владивосток", "Ярославль", "Хабаровск", "Махачкала", "Оренбург", "Новокузнецк", "Томск", "Кемерово", "Рязань", "Астрахань", "Пенза", "Набережные Челны", "Липецк", "Тула", "Киров", "Чебоксары", "Калининград", "Курск", "Улан-Удэ", "Ставрополь", "Магнитогорск", "Брянск", "Иваново", "Тверь", "Белгород", "Сочи", "Нижний Тагил"]

  actions:
    openMiniPopup: (which) ->
      @get('miniPopups').send('openPopup', which)
      false

    closeSecondMiniPopup: ->
      @get('miniPopups').send('closePopup')
      false

    chosenQuery: (defer, query) ->
      @store.find('dish', { search: query }).
      then(defer.resolve, defer.reject)

    createNewFood: (query) ->
      @get('chosenFood').addObject({
        name: query
      })
      false

    showNotification: ->
      @get('notifier').pushNotification
        type:    'success'
        title:   'Поступил новый заказ'
        message: "Уруру #{ _.random(0,100)}"
        duration: 5000

    buttonClicked: ->
      return if @get('buttonIsLoading')

      @set('buttonIsLoading', true)
      Em.run.later =>
        @set('buttonIsLoading', false)
      , 3000

    showOption: (option) ->
      false

    consoleLog: (args...) ->
      console.log(args)

